module.exports = __webpack_public_path__ + "static/media/RUSSELL K. RED 120 LOUDSPEAKERS.cc15c1aa.png";